// Lightweight service to fetch registry metadata (no auth required)
import { backendApiUrl } from '../config/backendApiUrl';

const registryUrl = (path) => backendApiUrl(`/api/registry${path}`);

async function fetchJson(url) {
  const res = await fetch(url, { credentials: 'include' });
  const contentType = res.headers.get('content-type') || '';
  const data = contentType.includes('application/json') ? await res.json() : await res.text();
  if (!res.ok) {
    const msg = typeof data === 'object' ? JSON.stringify(data) : String(data);
    const err = new Error(msg || `Request failed: ${res.status}`);
    err.status = res.status;
    err.response = data;
    throw err;
  }
  return data;
}

export async function getRegistryModels() {
  const r = await fetchJson(registryUrl('/models'));
  return r.data || [];
}

export async function getRegistryActions() {
  const r = await fetchJson(registryUrl('/actions'));
  return r.data || [];
}

export async function getRegistryCapabilities() {
  const r = await fetchJson(registryUrl('/capabilities'));
  return r.data || [];
}

export async function getRegistryCapabilitiesByModel(model) {
  const r = await fetchJson(registryUrl(`/capabilities/by-model?model=${encodeURIComponent(model)}`));
  return r.data || [];
}

export async function getRegistryActionsByModel(model) {
  const r = await fetchJson(registryUrl(`/actions/by-model?model=${encodeURIComponent(model)}`));
  return r.data || [];
}
